export default "__VITE_ASSET__BlwsYTQz__"